export default __webpack_public_path__ + "d407989f434a3f3ec9b53b23b09faf76.jpg";